import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  DateTimeFilter,
  File,
  GroupedSearchFilterFacet,
  SearchFilterFacet,
  SortOption,
} from '@savgroup-front-common/types';
import { SearchResultList } from '@savgroup-front-common/types/SearchResultList';

const ENDPOINT = `${APIConfiguration.search}filteredtodos`;

interface FilterTodosCommandArgs {
  query?: string;
  pageSize?: number;
  page?: number;
  isDescending?: boolean;
  sort?: string;
  filters?: SearchFilterFacet[];
  groupedFilters?: GroupedSearchFilterFacet[];
  dateTimeFilters?: DateTimeFilter[];
  sortOptions?: SortOption[];
  sellerId?: string;
  tenantId?: string;
}

export const filterTodosRequest = (
  payload: Record<string, unknown>,
): ApiRequestDescriptor => ({
  url: ENDPOINT,
  config: { method: SUPPORTED_METHODS.POST, json: payload },
});

async function filterTodosCommand({
  query,
  filters,
  page,
  pageSize,
  sort,
  isDescending,
  dateTimeFilters,
  sortOptions,
  groupedFilters,
  sellerId,
  tenantId,
}: FilterTodosCommandArgs): Promise<
  BackResponse<SearchResultList<File>> | BackResponseFailure
> {
  try {
    return await executeQuery<BackResponse<SearchResultList<File>>>(
      filterTodosRequest({
        query,
        filters,
        page,
        pageSize,
        sort,
        isDescending,
        dateTimeFilters,
        sortOptions,
        groupedFilters,
        sellerId,
        tenantId,
      }),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
}

export default filterTodosCommand;
